"use strict";
// Order of parameters in the object literals matches the order of function parameters
// tslint:disable:object-literal-sort-keys
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        /**
         * Used for popped out windows to communicate to the real InteractionManager as popped out windows do not have their own way of communication directly to the server.
         */
        var InteractionManagerProxy = /** @class */ (function () {
            function InteractionManagerProxy() {
                this.asyncMessageCount = 0;
            }
            InteractionManagerProxy.prototype.queueCallbackCommandInteraction = function (interaction, callback, channelOptions, shouldProcess, failureCallback) {
                if (this._canQueueInteraction(channelOptions)) {
                    interaction.windowId = $dyn.serverForm._windowId;
                    var data = {
                        source: "InteractionManager",
                        commandName: $dyn.serverForm.InteractionManagerFunction.queueCallbackCommandInteraction,
                        interaction: interaction,
                        callback: callback,
                        channelOptions: channelOptions,
                        shouldProcess: shouldProcess,
                        failureCallback: failureCallback,
                    };
                    this._postMessageToParentWindow(data);
                }
                else {
                    $dyn.logError($dyn.format($dyn.label("ServerForm_QueueError"), typeof interaction.details === "function" ? interaction.details() : interaction.$type));
                    $dyn.log.server && $dyn.log.server("ServerForm: Interaction %o", interaction);
                }
            };
            InteractionManagerProxy.prototype.queueThrottledCommandInteraction = function (interaction, callback, channelOptions, shouldProcess, throttleCallback, failureCallback) {
                if (this._canQueueInteraction(channelOptions)) {
                    interaction.windowId = $dyn.serverForm._windowId;
                    var data = {
                        source: "InteractionManager",
                        commandName: $dyn.serverForm.InteractionManagerFunction.queueThrottledCommandInteraction,
                        interaction: interaction,
                        channelOptions: channelOptions,
                        shouldProcess: shouldProcess,
                        callback: callback,
                        throttleCallback: throttleCallback,
                        failureCallback: failureCallback,
                    };
                    this._postMessageToParentWindow(data);
                }
                else {
                    $dyn.logError($dyn.format($dyn.label("ServerForm_QueueError"), typeof interaction.details === "function" ? interaction.details() : interaction.$type));
                    $dyn.log.server && $dyn.log.server("ServerForm: Interaction %o", interaction);
                }
            };
            InteractionManagerProxy.prototype.queueInteraction = function (interaction, channelOptions, shouldProcess, failureCallback) {
                if (this._canQueueInteraction(channelOptions)) {
                    interaction.windowId = $dyn.serverForm._windowId;
                    var data = {
                        source: "InteractionManager",
                        commandName: $dyn.serverForm.InteractionManagerFunction.queueInteraction,
                        interaction: interaction,
                        channelOptions: channelOptions,
                        shouldProcess: shouldProcess,
                        failureCallback: failureCallback,
                    };
                    this._postMessageToParentWindow(data);
                }
                else {
                    $dyn.logError($dyn.format($dyn.label("ServerForm_QueueError"), typeof interaction.details === "function" ? interaction.details() : interaction.$type));
                    $dyn.log.server && $dyn.log.server("ServerForm: Interaction %o", interaction);
                }
            };
            InteractionManagerProxy.prototype.queueTelemetryEvent = function (evt) {
                var data = {
                    source: "InteractionManager",
                    commandName: $dyn.serverForm.InteractionManagerFunction.queueTelemetryEvent,
                    event: evt,
                };
                this._postMessageToParentWindow(data);
            };
            InteractionManagerProxy.prototype.flushTelemetryEvents = function () {
                var data = {
                    source: "InteractionManager",
                    commandName: $dyn.serverForm.InteractionManagerFunction.flushTelemetryEvents,
                };
                this._postMessageToParentWindow(data);
            };
            InteractionManagerProxy.prototype.removePendingPersonalization = function (targetId, property, channelOptions) {
                if (this._canQueueInteraction(channelOptions)) {
                    var data = {
                        source: "InteractionManager",
                        commandName: $dyn.serverForm.InteractionManagerFunction.removePendingPersonalization,
                        targetId: targetId,
                        property: property,
                        channelOptions: channelOptions,
                    };
                    this._postMessageToParentWindow(data);
                }
                else {
                    $dyn.logError($dyn.format($dyn.label("ServerForm_QueueError"), "removePendingPersonalization"));
                }
            };
            InteractionManagerProxy.prototype.hasPendingResponse = function () {
                return $dyn.value($dyn.clientBusy);
            };
            InteractionManagerProxy.prototype.reset = function () { };
            InteractionManagerProxy.prototype._canQueueInteraction = function (channelOptions) {
                return !$dyn.serverForm.interactionHandler.processingInteractions || channelOptions.channelType === $dyn.serverForm.InteractionChannelType.available;
            };
            InteractionManagerProxy.prototype._postMessageToParentWindow = function (data) {
                // You cannot postMessage with an object that has functions; attempting to do so gives this error:
                // Uncaught DataCloneError: Failed to execute 'postMessage' on 'Window': An object could not be cloned.
                // We strip functions before the post and then restore them.
                if (!$dyn.parentWindow) {
                    $dyn.logError("Trying to post message to parentWindow which does not exist.");
                    return;
                }
                this.stripCallbackFunctions(data);
                var ret = $dyn.postMessage($dyn.parentWindow, { data: data });
                this.restoreCallbackFunctions(data);
                return ret;
            };
            /**
             * Remove functions from the message to a window-level callback map
             * @description Since we cannot send functions across postMessage we need to remove the functions and pass something that can be used to map to the function later.
             * Currently we are using a local functionId and passing that on to the InteractionManager,
             * who on the other side reconstructs a wrapper function which knows how to call this windows local function.
             * See InteractionManager:reconstructCallbackFunctions()
             *
             * Special casing for beforeExecute -- Since they would be executed immediately on the other side anyway, we just execute and strip them here.
             */
            InteractionManagerProxy.prototype.stripCallbackFunctions = function (data) {
                var interaction = data.interaction;
                if (interaction && (interaction.NoAsyncIncrement === undefined || interaction.NoAsyncIncrement === null || interaction.NoAsyncIncrement !== true)) {
                    var asyncMessageId_1 = this.asyncMessageCount++;
                    // In order to ensure that the async.pending flag is active on the popout window the entire time the interaction is being processed
                    // increment the async.pending count and append the decrementWindowAsyncPending function to the interaction.
                    // The decrementWindowAsyncPending function will be called if the interaction completes processing on the server as well as if it is dequeued from the throtled interaction queue.
                    $dyn.async.pending.increment("InteractionManagerProxy: Async message id " + asyncMessageId_1 + ", Post message to parent window start.");
                    interaction.decrementWindowAsyncPending = function () {
                        $dyn.async.pending.decrement("InteractionManagerProxy: Async message id " + asyncMessageId_1 + ", Post message to parent window end.");
                    };
                }
                // tslint:disable-next-line:forin
                for (var property in interaction) {
                    if (property === "beforeExecute") {
                        // beforeExecutes should be executed before postMessage to queue the interaction is sent to the main window.
                        // Stripping them off separately and executing now instead of passing them along.
                        interaction[property]();
                        delete interaction[property];
                        continue;
                    }
                    if (property === "ShouldBlockDeferred" && typeof interaction[property] === "function") {
                        // Compute and store the value of ShouldBlockDeferred before sending to the parent window.
                        interaction[property] = interaction[property]();
                    }
                    if (typeof interaction[property] === "function") {
                        this._createCallbackObject(interaction, property);
                    }
                }
                // Handle command callbacks. Converting to string in order to be able to use helper method.
                var callbacks = ["callback", "failureCallback", "throttleCallback"];
                // tslint:disable:prefer-for-of
                for (var i = 0; i < callbacks.length; i++) {
                    var callbackFunctionName = callbacks[i];
                    if (data[callbackFunctionName]) {
                        this._createCallbackObject(data, callbackFunctionName);
                        // Also set the windowId, as this will be used by the interaction manager when bucketing command callback interactions
                        data[callbackFunctionName].windowId = interaction.windowId;
                    }
                }
            };
            /**
             * Restore the interaction to its state prior to strip (excluding beforeExecute).
             * We need to do this for interactions with callbacks which call another function on the interaction.
             */
            InteractionManagerProxy.prototype.restoreCallbackFunctions = function (data) {
                var interaction = data.interaction;
                for (var property in interaction) {
                    if (interaction[property] && interaction[property]._functionId !== undefined && interaction[property]._functionId !== null) {
                        interaction[property] = $dyn.serverForm.idToWindowFunction[interaction[property]._functionId];
                    }
                }
            };
            /**
             * Stores functions from a parentObject into a local map.
             * Replaces the function with an object that holds the key to the function we just stored.
             */
            InteractionManagerProxy.prototype._createCallbackObject = function (parentObject, callbackFunctionName) {
                $dyn.serverForm.idToWindowFunction[$dyn.serverForm.windowFunctionId] = parentObject[callbackFunctionName];
                parentObject[callbackFunctionName] = {
                    _functionId: $dyn.serverForm.windowFunctionId,
                };
                $dyn.serverForm.windowFunctionId++;
            };
            return InteractionManagerProxy;
        }());
        serverForm.InteractionManagerProxy = InteractionManagerProxy;
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=InteractionManagerProxy.js.map
